<template>
    <div id="app">
        <div class="main">
            <div class="header">
                <div class="logo_img" @click="logoClick">
                    <div style="display:flex; align-items: center; float:left; height: 65px;">
                        <div class="header-logo">
                            <img id="header-img" src="../assets/xiaoba.jpg" >
                        </div>
                    </div>
                    <div style="display:flex; float:left; height: 65px;">
                        <div class="header-important">
                            <div class="company_name">杭州巴九灵文化创意股份有限公司</div>
                        </div>
                    </div>
                </div>
                <div id="menu_index">
                    <!-- web端菜单导航 -->
                    <el-menu v-if="seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" text-color="#333" style="height: 65px; border:0;" mode="horizontal" @select="handleSelect">
                        <el-menu-item index="1" class="header-title">首页</el-menu-item>
                        <el-menu-item index="2" class="header-title">吴晓波频道</el-menu-item>
                        <el-menu-item index="4" class="header-title">关于我们</el-menu-item>
                    </el-menu>
                </div>
            </div>
            <div class="container">
                <keep-alive>
                    <router-view></router-view>
                </keep-alive>
            </div>

            <div style="float:left;width: 100%;margin-top: 20px">
                <div style="width:90%; margin: auto;height:1px;padding:0;background-color:#999;">
                </div>
            </div>
            <div class="footer" style="margin: 10px">
                <div style="float: left; width: 100%">
                  <div style="margin: auto;" class="footer_font">
                    <div style="width:300px;margin:0 auto; padding:10px 0;">
                      <a href="https://beian.miit.gov.cn" target="_blank">
                        <p style="height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">浙ICP备16038658号</p>
                      </a>
                      <!--                            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502006950" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">-->
                      <!--                                <img src="../assets/beian.png" style="float:left;"/>-->
                      <!--                                <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">浙公网安备 33010502006950号</p>-->
                      <!--                            </a>-->
                    </div>
                  </div>
                    <p class="footer_font">浙江省杭州市西湖区白沙泉158号 0571-86535625</p>
                    <div style="margin: auto;" class="footer_font">
                        Copyright © 杭州巴九灵文化创意股份有限公司 All Rights Reserved
                    </div>
                </div>
            </div>
        </div>
        <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
            <p style="font-size: 0.625em; font-weight: bold">TOP</p>
            <img src="../assets/launch.png" style="height: 45px;width: 35px" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "Layout",
        data() {
            return {
                activeIndex: '1',
                scroll: '',
                timer: '',
                seen: true,
                currentMenu:'首页'
            };
        },
        methods: {
            handleSelect(key) {
                switch (key){
                    case '1':
                        this.$router.push({name: "Index"});
                        break;
                    case '2':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#吴晓波频道";
                        break;
                    case '4':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#关于我们";
                        break;
                }
            },
            handleScroll(){
                this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
                if( this.scroll >600 ){  //判断滚动后高度超过400px,就显示
                    this.$refs.btn.style.display = 'block';
                }else{
                    this.$refs.btn.style.display = 'none'
                }
            },
            backTop(){ //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
                this.timer = setInterval(() => {
                    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                    let ispeed = Math.floor(-osTop / 5)
                    document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                    if (osTop === 0) {
                        clearInterval(this.timer)
                    }
                }, 30)
            },
            menuSeen(){
                // 屏幕尺寸
                let screenHeight=document.body.clientWidth;
                if(screenHeight>415){
                    this.seen=true;
                }else{
                    this.seen=false;
                }
            },
            logoClick(){
                this.$router.push({name: "Index"});
                this.currentMenu='首页';
            }
        },
        mounted() {
            this.menuSeen()
            window.addEventListener('scroll', this.handleScroll)
        },
    }
</script>

<style scoped>
    .logo_img{
        float:left;
        width: 30%;
        cursor: pointer;
    }
    #back_to_top{
        position: fixed;
        bottom: 50px;
        right: 30px;
        cursor: pointer
    }
    .header-title{
        font-size: 1em;
    }
    .company_name{
        font-weight: normal;
        font-size: 1em;
    }
    .footer_font{
        font-size: 1em;
    }
    #menu_index{
        float: left; width: 50%;height: 100%
    }
    .header{
        margin: auto;
        width: 90%;
        height: 65px;
    }
    @media screen and (max-device-width: 415px) {
        .logo_img{
            float:left;
            width: auto;
            cursor: pointer;
        }
        #back_to_top{
            position: fixed;
            bottom: 50px;
            right: 5px;
            cursor: pointer
        }
        .footer_font{
            font-size: 0.875em;
        }
        #menu_index{
            float: right;
            width: auto;
            height: 100%
        }
    }
    .main{
        margin: auto;
        float: left;
        width: 100%;
        border: 0;
    }
    #header-img{
        width: 50px;
        height: 50px;
        float: left;
        margin: auto;
    }
    .header-logo{
        height: 50px;
        width: 50px;
        align-self: center;
    }
    .header-important{
        float: left;
        margin-left: 6px;
        align-self: center;
    }

    .footer{
        display: flex;
        align-items: center;
        margin: 10px auto;
        width: 90%;
    }
    a{text-decoration: none;}
    a:visited{text-decoration: none;}
    a:hover {text-decoration: none;}
    a:active{text-decoration:none;}
</style>
